import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { I } from '../Icons'

const Wrap = styled.div`
  margin: auto;
  text-align: center;
  padding: 24px 8px;
  max-width: 300px;
`

const Ill = styled.div`
  width: 76px;
  height: 76px;
  margin: 0 auto 14px;
  border-radius: 18px;
  background: linear-gradient(135deg, ${p => p.theme.colors.semantic.lilacTint}, #fff);
  border: 1px solid ${p => p.theme.colors.semantic.border};
  display: grid;
  place-items: center;
  color: ${p => p.theme.colors.semantic.accent};
`

const Title = styled.h3`
  font-family: ${p => p.theme.fontFamily.sans.join(', ')};
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 6px;
  letter-spacing: -0.01em;
`

const P = styled.p`
  font-size: 12px;
  color: ${p => p.theme.colors.semantic.textMuted};
  margin: 0 0 14px;
  line-height: 1.55;
`

const GenBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: ${p => p.theme.colors.semantic.accent};
  color: #fff;
  border: none;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background: ${p => p.theme.colors.semantic.accentHover};
  }
  &:disabled {
    opacity: 0.7;
    cursor: default;
  }
`

const Prompts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 16px;
`

const Prompt = styled.button`
  background: ${p => p.theme.colors.semantic.surface};
  border: 1px solid ${p => p.theme.colors.semantic.border};
  border-radius: 8px;
  padding: 8px 11px;
  font-size: 12px;
  color: ${p => p.theme.colors.semantic.textPrimary};
  text-align: left;
  line-height: 1.4;
  cursor: pointer;
  &:hover {
    border-color: ${p => p.theme.colors.semantic.accent};
    color: ${p => p.theme.colors.semantic.accent};
  }
`

const WipAiEmptyState = ({ onGenerate, disabled }) => (
  <Wrap>
    <Ill>
      <I.sparkle width={28} height={28} />
    </Ill>
    <Title>Start with a draft</Title>
    <P>
      I&apos;ll analyze April&apos;s numbers, surface action points, and draft a client-ready
      summary — all as <strong>Rev 1</strong>.
    </P>
    <GenBtn type="button" onClick={onGenerate} disabled={disabled}>
      <I.sparkle width={13} height={13} /> Generate Summary
    </GenBtn>
    <Prompts>
      <Prompt type="button">Summarize this month&apos;s WIP in 3 sentences.</Prompt>
      <Prompt type="button">Who is over their assignment?</Prompt>
      <Prompt type="button">Draft a client email flagging risks.</Prompt>
    </Prompts>
  </Wrap>
)

WipAiEmptyState.propTypes = {
  onGenerate: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default WipAiEmptyState
